
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';

import { GetBedStatus, AddBedStatus } from '../../redux/actions/SettingAction'
import { SuccessToast, ErrorToast } from '../../redux/actions/ToasterAction';
import { ShowSpinner, HideSpinner } from '../../redux/actions/SpinnerAction';

import ProInputText from "../../components/common/ProInputText";
import ProTextArea from "../../components/common/ProTextArea";
import ProCheckBox from "../../components/common/ProCheckbox";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useFormik } from "formik";
import { useDialogService } from '../../hooks/useDialogService';

import { Severity } from '../../constants/ProConstants';
import {duplicateCheck} from "../../utilities/Helper"
import _ from 'lodash'
const initialState = {
    name: '',
    description: '',
    isActive: true,
    assignmentInd: true,
    reservationInd: true,
};
const ManageBedStatus = ({ globalFilter, toggleSideBar, addNew }) => {  
    const [formData, setFormData] = useState(initialState)
    const [headingText, setHeadingText] = useState('Add New Bed Status');
    const {actions:{ShowDialog}} = useDialogService();
    const { height } = useWindowDimensions();

    let items = [
        { label: 'Edit', icon: 'fas fa-edit', command: (e) => { onEdit(e) } },
    ];

    const allBedStatus = useSelector((state) => {
        return state.setting.allBedStatus;
    })

    const dispatch = useDispatch();
    const GetAllBedStatus = useCallback(async (node, data) => {
        dispatch(ShowSpinner());
        var action = await GetBedStatus();
        dispatch(action);
        dispatch(HideSpinner());      

    }, [dispatch])


    useEffect(() => {
        GetAllBedStatus();
    }, [GetAllBedStatus]);

    const onEdit = (e) => {
        setFormData(e.item.data)
        setHeadingText('Edit Bed Status');
        addNew()
    }

    const toggleMenu = (menu, event, rowData) => {
        items.forEach((menuItem) => {
            menuItem.data = rowData;
        });
        menu && menu.toggle(event);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            rowData.isEditable &&
            <React.Fragment>
                <i className="pi pi-ellipsis-h" onClick={(event) => toggleMenu(rowData.menuRef, event, rowData)}></i>
                <Menu model={items} popup ref={(el) => rowData.menuRef = el} />
            </React.Fragment>
        );
    }

    const formik = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(_.trim(data.name))) {
                errors.name = `Name is required.`;
            }
            if (!_.isEmpty(data.name) && data.name.length > 120) {
                errors.name = "Max 120 characters allowed";
            }
            if (!_.isEmpty(data.name) && duplicateCheck(allBedStatus,'name', data)) {
                errors.name = "Bed status name already exists!";
            }
            if (!_.isEmpty(data.description) && data.description.length > 500) {
                errors.description = "Max 500 characters allowed";
            }
            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    });
    const resetFormik = useCallback(() => {
        setFormData(initialState)
        formik.resetForm()
        addNew();
        setHeadingText('Add New Bed Status');
    },[formik, addNew])

    const handleSubmit = useCallback(async (data) => {
        try 
        {
            data = _.omit(data, ['menuRef']);
            data.name =_.trim(data.name);
            dispatch(ShowSpinner());
            var action = await AddBedStatus(data);
            dispatch(action);
            dispatch(HideSpinner());
            if(data.id){
                dispatch(SuccessToast('Success', 'Updated Successfully!'));
            } else {
                dispatch(SuccessToast('Success', 'Saved Successfully!'));
            }
            GetAllBedStatus();
        }
        catch(err) {
            dispatch(HideSpinner());
            dispatch(ErrorToast('Error', _.get(err, 'response.data.message')));
        }
        resetFormik()
    }, [dispatch, GetAllBedStatus, resetFormik])

    const handleActiveChanged = async (checked)=>{
        if(!checked){
            await ShowDialog(`Inactivate ${formik.values.name} Bed Status?`, null,null, "Yes, Inactivate", "Cancel", Severity.Danger,
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: checked})
                        },
                        ()=>{
                            formik.setValues({ ...formik.values, isActive: true })
                        })
        }else{
            formik.setValues({ ...formik.values, isActive: checked })
        }
    }

   
    return (<div>
        <Sidebar dismissable={false} modal={false}
            visible={toggleSideBar} position="right"
            style={{ width: '30em', zIndex: 1103 }} onHide={() => resetFormik()} icons={() => (
                <h6 className="p-sidebar-close"
                    style={{
                        fontWeight: '700', fontSize: '20px', width: '100%',
                        margin: 'auto'
                    }}>{headingText}</h6>
            )}>
            <form onSubmit={formik.handleSubmit}>
                <ProInputText
                    headerText="Name"
                    id="name"
                    labelText="Name"
                    formik={formik}
                    name="name"
                    error="name"
                    required
                    value={formik.values.name}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, name: e.target.value });
                    }}
                />
                <ProTextArea
                    rows={7} cols={30}
                    headerText="Description"
                    id="description"
                    labelText="Description"
                    value={formik.values.description}
                    formik={formik}
                    name="description"
                    error="description"
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, description: e.target.value });
                    }}
                    showCounter
                />
                <ProCheckBox
                    id="isActive"
                    name="isActive"
                    labelText="Active"
                    checked={formik.values.isActive}
                    disabled = {!formik.values.allowInactivate}
                    onChange={(e) => handleActiveChanged(e.target.checked)}
                />
                <ProCheckBox
                    id="assignmentInd"
                    name="assignmentInd"
                    labelText="Allow Assignment"
                    checked={formik.values.assignmentInd}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, assignmentInd: e.target.checked });
                    }}
                />
                <ProCheckBox
                    id="reservationInd"
                    name="reservationInd"
                    labelText="Allow Reservation"
                    checked={formik.values.reservationInd}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, reservationInd: e.target.checked });
                    }}
                />
                <div className="p-d-flex p-jc-start" style={{ marginTop: "25px" }}>
                    <Button label="Cancel" type="button" className="p-button-text" onClick={() => { resetFormik() }} style={{ color: "#34436d" }} />
                    <Button label="Save" type="submit" style={{ backgroundColor: "#34436d" }} />
                </div>
            </form>
        </Sidebar>

        <DataTable value={allBedStatus}
            dataKey="id"
            breakpoint="960px"
            header="Bed Status"
            globalFilter={globalFilter}
            responsiveLayout="stack"
            scrollable scrollHeight={`${height-225}px`} > 
            <Column field="name" header="Name" sortable></Column>
            <Column field="description" header="Description" sortable style={{ width: '30%' }}></Column>
            <Column field="isActive"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.isActive ? 'active' : 'inactive'}`}>{rowData.isActive ? 'Active' : 'Inactive'}</span>;
                }}
                header="Active" sortable></Column>
            <Column field="assignmentInd"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.assignmentInd ? 'active' : 'inactive'}`}>{rowData.assignmentInd ? 'Yes' : 'No'}</span>;
                }}
                header="Allow Assignment" sortable></Column>
            <Column field="reservationInd"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.reservationInd ? 'active' : 'inactive'}`}>{rowData.reservationInd ? 'Yes' : 'No'}</span>;
                }}
                header="Allow Reservation" sortable></Column>
            <Column body={actionBodyTemplate} style={{ width: '5%' }}></Column>
        </DataTable>
    </div>)

}

export default ManageBedStatus;